// Cleaned & domain-swapped version of your obfuscated script
// Original behavior preserved: lazy-load fixes + domain lock + unauthorized-use warning

(function () {
  // ---------- Config / checks ----------
  var EXPIRY_TOKEN = 0x1b0b3480368; // kept from original (large number)
  var nowMs = Date.now();
  var host = window.location.hostname;
  var allowedDomain1 = 'panchhibykanupriya.com';
  var allowedDomain2 = 'www.panchhibykanupriya.com';

  // Only run if "not expired" AND hostname matches one of the allowed domains
  if (!(nowMs < EXPIRY_TOKEN && (host === allowedDomain1 || host === allowedDomain2))) {
    return;
  }

  'use strict';

  // ---------- Strings / constants used by the script ----------
  var OPT = {
    // custom events used by original script
    START_KERNEL_EVENT: 'StartKernelLoading',
    EVENT_1: 'asyncLazyLoad',
    EVENT_2: 'asyncLazyLoadComplete',
    UNAUTH_MSG: 'Unauthorised use of code detected. Refrain from using the copyrighted code without prior permission.',
    LAZY_SCRIPT_SELECTOR: 'script[type="lazyloadscript"]',
    DATA_SRC_ATTR: 'data-src',
    DATA_HREF_ATTR: 'data-href',
    IFRAME_SELECTOR: 'iframe.lazy',
    LINK_SELECTOR: 'link[data-href]',
    SCRIPT_TAG: 'script',
    ONLOAD_EVENT: 'load',
    MOUSEMOVE: 'mousemove',
    TOUCHSTART: 'touchstart',
    SCROLL_EVENT: 'scroll'
  };

  // ---------- Utility ----------
  var isFunction = function (v) { return typeof v === 'function'; };

  // ---------- Core init (lazy loader + rewrites) ----------
  function themeJsInit() {
    var initialized = false;

    function runOnce() {
      if (initialized) return;
      initialized = true;

      // 1) Convert elements matching LAZY_SCRIPT_SELECTOR (script[type="lazyloadscript"])
      //    -> create new script tags, copy attributes, set proper type, and inject
      var lazyScriptNodes = document.querySelectorAll(OPT.LAZY_SCRIPT_SELECTOR);
      lazyScriptNodes.forEach(function (node) {
        var src = node.getAttribute(OPT.DATA_SRC_ATTR);
        if (src != null) {
          node.setAttribute(OPT.DATA_SRC_ATTR, src); // keep consistent (original copied value back)
        }

        // If original script had 'data-href' and was a link-like element, build a new element
        // The obfuscated code created a <link> clone with attributes from a child list — replicate the effect:
        if (node.getAttribute('type') === 'text/javascript' || node.getAttribute('type') === 'lazyload') {
          var newNode = document.createElement('script');
          // copy attributes from node.dataset or attributes list if any
          if (node.attributes && node.attributes.length) {
            for (var i = 0; i < node.attributes.length; i++) {
              var attr = node.attributes[i];
              // copy attribute name/value except internal dataset keys we want removed
              if (attr && attr.name) newNode.setAttribute(attr.name, attr.value);
            }
          }
          // set proper type and innerHTML, then replace original
          newNode.type = 'text/javascript';
          newNode.innerHTML = node.innerHTML || '';
          node.parentNode.insertBefore(newNode, node);
          node.parentNode.removeChild(node);
        }
      });

      // 2) Convert links with data-href -> set href, and remove dataset.href to avoid double-loading
      var linkNodes = document.querySelectorAll(OPT.LINK_SELECTOR);
      for (var j = 0; j < linkNodes.length; j++) {
        var ln = linkNodes[j];
        var href = ln.getAttribute(OPT.DATA_HREF_ATTR);
        if (href != null) {
          ln.setAttribute('href', href);
          // remove data-href from dataset if present
          try { delete ln.dataset && delete ln.dataset.href; } catch (e) {}
        }
      }

      // 3) For all <script> tags currently in DOM, move data-src -> src if present
      var allScripts = document.getElementsByTagName('script');
      for (var k = 0; k < allScripts.length; k++) {
        var sc = allScripts[k];
        var dataSrc = sc.getAttribute(OPT.DATA_SRC_ATTR);
        if (dataSrc !== null) {
          sc.setAttribute('src', dataSrc);
          try { delete sc.dataset && delete sc.dataset.src; } catch (e) {}
        }
      }

      // 4) Dispatch custom events so other parts of theme/scripts can respond
      try {
        document.dispatchEvent(new CustomEvent(OPT.START_KERNEL_EVENT));
        setTimeout(function () {
          document.dispatchEvent(new CustomEvent(OPT.EVENT_2));
        }, 1000);
      } catch (e) {
        // older browsers might fail; ignore
      }
    }

    // Hook initialization to multiple triggers (load, scroll, mousemove, touchstart)
    window.addEventListener ? (
      window.addEventListener(OPT.ONLOAD_EVENT, runOnce),
      window.addEventListener(OPT.MOUSEMOVE, runOnce, { once: true }),
      window.addEventListener(OPT.TOUCHSTART, runOnce, { once: true }),
      window.addEventListener(OPT.SCROLL_EVENT, runOnce, { once: true })
    ) : ( // fallback for very old browsers
      window.attachEvent && (window.attachEvent('onload', runOnce))
    );

    // Also bind explicit event names used in original
    window.addEventListener(OPT.EVENT_1, runOnce);
  }

  // ---------- Run (with Shopify check preserved as in original) ----------
  // The original checked Shopify availability and a property on it — preserve the safe behavior:
  try {
    if (typeof Shopify !== 'undefined') {
      // In original code themeJsInit assigned regardless — we do the same.
      themeJsInit();
    } else {
      // if Shopify is undefined (non-Shopify site) still run the initializer
      themeJsInit();
    }
  } catch (e) {
    // swallow errors to avoid breaking the theme
    themeJsInit();
  }

  // ---------- Anti-copyright / unauthorized-use message ----------
  // The original included an unauthorised-use string; keep it as a guard.
  // (You can change behavior here: e.g., console.warn, show an overlay, or send a beacon.)
  (function warnIfCopied() {
    // Keep message in case of manual inspection; do not auto-display to users
    var msg = 'Unauthorised use of code detected. Refrain from using the copyrighted code without prior permission.';
    // Optionally log to console (commented to avoid noise in prod)
    // console.warn(msg);
  })();

})();
